<template>
  <div class="col-lg-4">
    <div class="card">
      <div class="card-header">
        <div class="row align-items-center">
          <div class="col">
            <h4 class="card-title">Recent Registered Members</h4>
          </div>
        </div>
      </div>

      <div class="card-body">
        <div class="analytic-dash-activity" data-simplebar>
          <div class="activity">
            <template
                v-if="
                    recentRegisteredCustomers.data &&
                    recentRegisteredCustomers.data.length
                  "
            >
              <div
                  class="activity-info"
                  v-for="(item, index) in recentRegisteredCustomers.data"
                  :key="index"
              >
                <div class="icon-info-activity">
                  <router-link
                      class="custom-link"
                      :to="{
                          name: 'showCustomer',
                          params: { id: item.customer_id },
                        }"
                  >
                    <!-- <i class="las la-user-clock bg-soft-primary"></i> -->
                    <img
                        v-if="getMemberPhotoThumb(item)"
                        :src="getMemberPhotoThumb(item)"
                        :alt="`${item.first_name} photo`"
                        class="rounded-circle thumb-md"
                        width="50"
                    />
                    <!-- <i v-else class="las la-user-clock bg-soft-primary"></i> -->
                    <img
                        v-else-if="item.gender === 'Female'"
                        :src="noUserFemaleImage"
                        :alt="`${item.first_name} photo`"
                        class="rounded-circle thumb-md"
                        width="50"
                    />

                    <img
                        v-else
                        :src="noUserImage"
                        :alt="`${item.first_name} photo`"
                        class="rounded-circle thumb-md"
                        width="50"
                    />
                  </router-link>
                </div>
                <div class="activity-info-text">
                  <div
                      class="d-flex justify-content-between align-items-center"
                  >
                    <router-link
                        class="custom-link"
                        :to="{
                            name: 'showCustomer',
                            params: { id: item.customer_id },
                          }"
                    >
                      <p class="text-muted mb-0 font-13">
                            <span>{{ item?.customer_no }}</span
                            ><br />
                        {{ item?.full_name }}
                      </p>
                    </router-link>
                    <small class="text-muted"
                    >{{ timeSinceRegistered(item?.created_at) }}
                    </small>
                  </div>
                </div>
              </div>
            </template>

            <records-not-found v-else />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script >
import { defineComponent } from "vue";
import { numberFormatter,timeSinceRegistered } from "@/filters";
import { capitalizeFirstLetter } from "@/helpers/utils";
import noUserImage from "@/assets/images/users/no-user.jpg";
import noUserFemaleImage from "@/assets/images/users/no-user-female.jpg";

export default defineComponent({
  name: "RecentRegisteredCustomers",
  props: {
    recentRegisteredCustomers: Object,
    translations:Object
  },
  data: () => ({}),
  // setup
  setup() {

    function getMemberPhotoThumb(item) {
      if (item && item.member_photo && item.member_photo.length > 0) {
        return item.member_photo[0].thumb_path;
      }
      return null;
    }
    return {
      numberFormatter,
      capitalizeFirstLetter,
      getMemberPhotoThumb,
      noUserImage,
      noUserFemaleImage,
      timeSinceRegistered
    };

  }
});
</script>
